/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionPartnerPageItemVo } from './CommissionPartnerPageItemVo';
import {
    CommissionPartnerPageItemVoFromJSON,
    CommissionPartnerPageItemVoFromJSONTyped,
    CommissionPartnerPageItemVoToJSON,
    CommissionPartnerPageItemVoToJSONTyped,
} from './CommissionPartnerPageItemVo';

/**
 * 
 * @export
 * @interface PageDataCommissionPartnerPageItemVo
 */
export interface PageDataCommissionPartnerPageItemVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataCommissionPartnerPageItemVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataCommissionPartnerPageItemVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataCommissionPartnerPageItemVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<CommissionPartnerPageItemVo>}
     * @memberof PageDataCommissionPartnerPageItemVo
     */
    records?: Array<CommissionPartnerPageItemVo>;
}

/**
 * Check if a given object implements the PageDataCommissionPartnerPageItemVo interface.
 */
export function instanceOfPageDataCommissionPartnerPageItemVo(value: object): value is PageDataCommissionPartnerPageItemVo {
    return true;
}

export function PageDataCommissionPartnerPageItemVoFromJSON(json: any): PageDataCommissionPartnerPageItemVo {
    return PageDataCommissionPartnerPageItemVoFromJSONTyped(json, false);
}

export function PageDataCommissionPartnerPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataCommissionPartnerPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(CommissionPartnerPageItemVoFromJSON)),
    };
}

export function PageDataCommissionPartnerPageItemVoToJSON(json: any): PageDataCommissionPartnerPageItemVo {
    return PageDataCommissionPartnerPageItemVoToJSONTyped(json, false);
}

export function PageDataCommissionPartnerPageItemVoToJSONTyped(value?: PageDataCommissionPartnerPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(CommissionPartnerPageItemVoToJSON)),
    };
}

